/**
 * 资料库相关的接口
 */

import 'babel-polyfill'
function getErrorCodeInfo (code, page) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/example/error_code',
      type: 'get',
      data: {
        code: code,
        page: page
      },
      dataType: 'json',
      success: function (data) {
        resolve(data)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

export {
  getErrorCodeInfo
}



// WEBPACK FOOTER //
// ./src/js/api/document.js